import CategoriesSolidSVG from "@design-system/ui-icons/vanilla/CategoriesSolid"
import { createIcon } from "../createIcon"

export const CategoriesSolidIcon = createIcon(CategoriesSolidSVG)
